'use client'

import { useEffect } from 'react'

export default function Home() {
  useEffect(() => {
    window.location.href = '/43os.html'
  }, [])

  return (
    <div
      style={{
        background: '#111111',
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <p
        style={{
          fontFamily: "'Inter', -apple-system, sans-serif",
          fontWeight: 800,
          fontSize: 26,
          letterSpacing: '-0.04em',
          color: '#fff',
          display: 'inline-flex',
          alignItems: 'center',
          gap: '0.2em',
        }}
      >
        43
        <span style={{ background: '#FFD400', color: '#111111', padding: '0.16em 0.2em' }}>OS</span>
      </p>
    </div>
  )
}
